import TournamentsService from "@/lib/Tournaments";
import type { InvestingTournamentLeaderboard } from '@bloom/postgresql/entities/game/investing-tournament/investing-tournament-leaderboard.entity';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";


type LeaderBoardEntity = InvestingTournamentLeaderboard & {
  firstName: string
  lastName: string
  userId: string
}

type LeadarboardData = {
  currentPosition: number;
  leaderboard: LeaderBoardEntity[];
}

export default function useTournamentLeaderboard(id: string) {
  const queryClient = useQueryClient();

  const {data, isLoading, error } = useQuery<LeadarboardData,  Error>({
    queryKey: ['leaderboard', id],
    queryFn: async () => TournamentsService.getTournamentLeaderboard(id),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: !!id
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: ['leaderboard', id],
      });
    };
  }, [id, queryClient]);


  return {
    leaderboard: data?.leaderboard,
    currentPosition: data?.currentPosition,
    isLoading,
    error
  }
}